import { axiosClient } from '@/libs/axios-client';

const BASE = '/compensation';

export const getEmployeeCompensation = async (employeeId) => {
  const { data } = await axiosClient.get(`${BASE}/employees/${employeeId}`);
  return data;
};

export const getCompensationCompanies = async () => {
  const { data } = await axiosClient.get(`${BASE}/companies`);
  return data?.items || [];
};

export const getCompanyCompensationList = async (companyId) => {
  const { data } = await axiosClient.get(
    `${BASE}/companies/${companyId}/employees`
  );
  return data?.items || [];
};

export const getSalaryViewers = async (companyId) => {
  const { data } = await axiosClient.get(
    `${BASE}/companies/${companyId}/viewers`
  );
  return data;
};

export const setSalaryViewers = async (companyId, userIds) => {
  const { data } = await axiosClient.put(
    `${BASE}/companies/${companyId}/viewers`,
    { userIds }
  );
  return data;
};

export const getSalaryManagers = async (companyId) => {
  const { data } = await axiosClient.get(
    `${BASE}/companies/${companyId}/managers`
  );
  return data;
};

export const setSalaryManagers = async (companyId, body) => {
  const { data } = await axiosClient.put(
    `${BASE}/companies/${companyId}/managers`,
    body
  );
  return data;
};

export const getPayslipPublication = async (companyId) => {
  const { data } = await axiosClient.get(
    `${BASE}/companies/${companyId}/payslip-publication`
  );
  return data;
};

/** Publishes through a month, or withdraws back to it; null withdraws all. */
export const setPayslipPublication = async (companyId, period) => {
  const { data } = await axiosClient.put(
    `${BASE}/companies/${companyId}/payslip-publication`,
    { period }
  );
  return data;
};

/** The closed AB payslip of a month as a PDF, saved by the browser. */
export const downloadPayslipPdf = async (employeeId, period, language) => {
  const response = await axiosClient.get(
    `${BASE}/employees/${employeeId}/payslips/${period}/pdf`,
    { params: { language }, responseType: 'blob' }
  );
  const name =
    /filename="([^"]+)"/.exec(response.headers?.['content-disposition'] || '')?.[1] ||
    `listic-${period}.pdf`;
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.click();
  URL.revokeObjectURL(url);
};
